import { HandballIcon } from './HandballIcon';

/**
 * author: Google
 * id 845C7000-7198-490F-8043-EC1F61CE4F53
 * name handball
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/handball.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanHandballIcon = HandballIcon;
export default HumanHandballIcon